import { Outlet } from "react-router-dom";
import { Sidebar } from "./components/Sidebar";
import { useWalletAccountTracking } from "./lib/connectedAccount";

/**
 * The shell for a signed-in operator wallet: the sidebar and the routed page.
 * A wallet account change signs nobody out: the session is the operator
 * wallet's, and the connected account only decides who sends an on-chain change.
 */
export function App() {
  useWalletAccountTracking();
  return (
    <div className="console-app">
      <Sidebar />
      <main className="console-main">
        <Outlet />
      </main>
    </div>
  );
}
